import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { LiveMemo } from '@C/LiveMemo/RouteComponents';

const RouteSetup = () => {
  return (
    <Switch>
      <Route path="/account/live-memo" component={LiveMemo} />
      <Route path="/account/live-memo/*">
        <Redirect to={`/account/live-memo`} />
      </Route>
    </Switch>
  );
};

export { RouteSetup };
